import { Component, ElementRef, ViewChild, HostListener } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { AppointmentService } from '../../services/appointment.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { merge, startWith, switchMap, catchError, map, of as observableOf, Subject, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { IpdAppointmentService } from '../../services/ipdappointment.service';
import { environment } from 'src/environments/environment';
import { MasterService } from '../../services/master.service';
import { UsersService } from '../../services/users.service';
import * as XLSX from 'xlsx';
import * as moment from 'moment';

@Component({
  selector: 'app-ipd',
  templateUrl: './ipd.component.html',
  styleUrls: ['./ipd.component.scss']
})
export class IpdComponent {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  isMobileView = window.innerWidth <= 1024;
  scrollThumbWidth = 10;
  scrollThumbLeft = 0;
  initialLoad: boolean = true;
  isDataLoading: boolean = true;
  topBarTitle: string = "In Patient";
  isLoading = false;
  btnLoading:boolean = false;
  totalRows = 0;
  patientRecord:any = {
    prefix:"",
    fname:"",
    lname:"",
    mobile:"",
    email:"",
    patient_id:"",
    age:"",
    gender:"",
    pId:"",
    address:"",
    custodian:""
  };
  pageSize = 10;
  currentPage = 0;
  pageSizeOptions: number[] = [10, 25, 100];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  searchQuery = new FormControl();
  dateQuery = new FormControl();
  formAction = "add";
	closeResult = '';
  isSubmitted: boolean = false;
  procedureList:any = [];
  doctorList:any = [];
  diagnosisTemplateURL:any = environment.getDiagnosisTemplate;
  admissionTemplateURL:any = environment.getAdmissionTemplate;
  procedureListURL:any = environment.getAllPriceMaster;
  ipdAppointment:IpdAppointment =  new IpdAppointment();
  @ViewChild("ipdAppointmentForm")
  ipdAppointmentForm!: NgForm;
  @ViewChild('SubmitForm')
  SubmitForm!: ElementRef;
  displayedColumns: string[] = ["pId","info","name","date","status","action"];
  exportColumns:any = ["pId","Ipd No","Name","Doctor In Charge","Date","Time","Status"];
  exportArrayData:any = []
  diagnosisValues:any = [];
  admissionValues:any = [];
  procedureValues:any = [];
  doctorInchargeid:any = "";
  doctorInchargeObject:any = {};

  // Premium Dashboard Additions
  mobileInfoVisible : any;
  current_id_hover: any;
  topPosition: any;
  leftPosition: any;
  hoveredRow: any;
  showOpdFeature: boolean = false;
  isHospitalWise: boolean = false;
  departmentListDp: any = [];
  DoctorDpList: any = [];
  filtersObject: any = {};

  selected_tab = 'all';
  selectedStatus = '';
  statusFilter$ = new BehaviorSubject<string>('');
  overviewStats: any = {
    total: 0,
    admitted: 0,
    waiting: 0,
    discharged: 0,
    cancelled: 0
  };
  overviewStatsSubject = new Subject<any>();

  app_count: any = {
    all: null,
    today: null,
    tomorrow: null,
    week: null,
    month: null
  };

  reminderFollowUp = false;
  reminderUpcoming = false;
  reminderSending = false;

  constructor(private user:UsersService,private router:Router, private toast:ToastrService, private api:IpdAppointmentService,private modalService: NgbModal, private localStorage:LocalStorageService)
  {
    this.isHospitalWise = this.localStorage.getHospitalWise() == "true";
    this.showOpdFeature = this.localStorage.checkFeatures('opd');
  }
  onDoctorChange(event:any)
  {
   let id = event.target.value;
   if(id)
   {
    let selectedDoctor = this.doctorList.filter((item:any)=>item.user_id = id);
    this.doctorInchargeObject = selectedDoctor[0]
   }
  }
  ngAfterViewInit() {
    // Subscribe to overview stats
    this.overviewStatsSubject.pipe(
      switchMap((param: any) => {
        return this.api.getIpdOverviewStats(param).pipe(
          catchError(() => observableOf({ stats: { total: 0, admitted: 0, waiting: 0, discharged: 0, cancelled: 0 } }))
        );
      })
    ).subscribe((res: any) => {
      if (res && res.stats) {
        this.overviewStats = {
          total: res.stats.total || 0,
          admitted: res.stats.admitted || 0,
          waiting: res.stats.waiting || 0,
          discharged: res.stats.discharged || 0,
          cancelled: res.stats.cancelled || 0
        };
      }
    });

    this.loadData();
    this.updateScrollThumb();
    setTimeout(() => this.updateScrollThumb(), 100);
  }
  ngOnInit(): void { 
    
  }

  searchFilter(event:any){
    this.searchQuery.setValue(event);
  }

  loadData() {
    try {
      this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      merge(
        this.dateQuery.valueChanges,
        this.searchQuery.valueChanges,
        this.sort.sortChange,
        this.paginator.page,
        this.statusFilter$
      ).pipe(
        startWith({}),
        switchMap(() => {
          this.isDataLoading = true;
          let param: any = {
            where: { hospital_id: this.localStorage.getHospitalId(), center_id: this.localStorage.getCenterId() },
            filter: this.searchQuery.value,
            custom_filter: this.filtersObject,
            page: (this.paginator.pageIndex * this.paginator.pageSize),
            limit: this.paginator.pageSize,
            order: [{ col: 'date_of_admission', dir: "desc" }, { col: 'time_of_admission', dir: "desc" }],
          };
          if (this.dateQuery.value) { param = { ...param, ...this.dateQuery.value }; }
          if (this.selectedStatus) {
            param = { ...param, status: this.selectedStatus };
          }

          this.fetchOverviewStats(param);

          return this.api.getAllIpdAppointmentWithCount(param).pipe(
            catchError(() => observableOf(null))
          );
        }),
        map((response: any) => {
          this.initialLoad = false;
          if (response === null) {
            return [];
          }
          if (this.selected_tab === 'all') {
            this.app_count = { all: response.count, today: null, tomorrow: null, week: null, month: null };
          } else if (this.selected_tab === 'today') {
            this.app_count = { all: null, today: response.count, tomorrow: null, week: null, month: null };
          } else if (this.selected_tab === 'tomorrow') {
            this.app_count = { all: null, today: null, tomorrow: response.count, week: null, month: null };
          } else if (this.selected_tab === 'week') {
            this.app_count = { all: null, today: null, tomorrow: null, week: response.count, month: null };
          } else if (this.selected_tab === 'month') {
            this.app_count = { all: null, today: null, tomorrow: null, week: null, month: response.count };
          }
          this.totalRows = response.count;
          return response;
        })
      ).subscribe({
        next: (data: any) => {
          this.initialLoad = false;
          this.isDataLoading = false;
          if (data && data.rows) {
            this.exportArrayData = data.rows;
            this.dataSource = new MatTableDataSource<any>(data.rows);
          } else {
            this.exportArrayData = [];
            this.dataSource = new MatTableDataSource<any>([]);
          }
        },
        error: (e) => {
          this.initialLoad = false;
          this.isDataLoading = false;
          console.error(e);
        },
        complete: () => {
          this.initialLoad = false;
        }
      });
    } catch (e) {
      this.initialLoad = false;
      console.error(e);
    }
  }
  open(content:any){
    this.loadDoctors();
    this.modalService.open(content, { size:'xl', scrollable: true, centered: true}).result.then(
			(result) => {
				this.closeResult = `Closed with: ${result}`;
			},
			(reason) => {
				this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
			},
		);
  }
  closeModal()
  {
    this.modalService.dismissAll()
    this.ipdAppointment = new IpdAppointment();
  }

  loadDoctors()
  {
    let param = {
       hospital_id:this.localStorage.getHospitalId(),
       center_id:this.localStorage.getCenterId(),
       roles:['Doctor', "Ophthalmologist","Surgeon"]
    }
    this.user.getDoctors(param).subscribe({
      next:(res)=>{
         this.doctorList = res;
      },
      error:(e)=>{
        console.log(e)
      }
    })
  }
  dateFilter(query:any){
    this.dateQuery.setValue(query)
  }
  getDismissReason(reason: any): string {
		if (reason === ModalDismissReasons.ESC) {
			return 'by pressing ESC';
		} else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
			return 'by clicking on a backdrop';
		} else {
			return `with: ${reason}`;
		}
	}
  
  createIpdAppointment(isValid:boolean)
  {
    console.log("IPD data : ",this.ipdAppointment);
    this.isSubmitted = true;
    if(isValid)
    {
      this.btnLoading = true;
      this.ipdAppointment.reason_for_admission = this.admissionValues
      this.ipdAppointment.diagnosis = this.diagnosisValues
      this.ipdAppointment.procedures = this.procedureValues
      this.ipdAppointment.doctor_incharge = this.doctorInchargeObject
      this.ipdAppointment.hospital_id = this.localStorage.getHospitalId();
      this.ipdAppointment.center_id = this.localStorage.getCenterId();
      
      //console.log(this.ipdAppointment)

      this.api.createIPDAppointment(this.ipdAppointment).subscribe({
        next:(res)=>{
          if(res)
          {
            this.toast.success("IPD Patient Admitted");
            this.modalService.dismissAll();
            this.ipdAppointment = new IpdAppointment();
            this.isSubmitted = false;
            this.loadData();
            this.btnLoading = false;
          }
        },
        error:(e)=>{
          console.log(e)
          this.btnLoading = false;
        }
      })
    }

  }
  getPatientRecord(data:any)
  {
    this.ipdAppointment.patient_id = data.id
    this.ipdAppointment.prefix = data.prefix
    this.ipdAppointment.fname = data.fname
    this.ipdAppointment.lname = data.lname
    this.ipdAppointment.mobile = data.mobile
    this.ipdAppointment.email = data.email
    this.ipdAppointment.age = data.age
    this.ipdAppointment.gender = data.gender
    this.ipdAppointment.address = data.address
  }
  getAdmissionValues(data:any){this.admissionValues = data}
  getDiagnosisValues(data:any){this.diagnosisValues = data} 
  getProcedureValues(data:any){this.procedureValues = data} 
  goToIPD(item:any)
  {
    localStorage.setItem('pId', item.pId);
    const serialized = this.router.serializeUrl(
      this.router.createUrlTree(['main/in-patient/record', item.id, item.ipdappointment.id])
    );
    window.open(window.location.pathname + '#' + serialized, '_blank');
  }

  openReschedule(content:any,item:any)
  {


    this.modalService.open(content,  { size:'sm', scrollable: false,ariaLabelledBy: 'modal-basic-title',centered: true }).result.then((result) => {  
      if (result === 'yes') {  
       // this.deleteSchedule(item.schedule_id)
      }  
    }, (reason) => {  

    });  
  }
  
  cancelAppointmentfn(content:any,item:any)
  {
    this.modalService.open(content,  { size:'sm', scrollable: false,ariaLabelledBy: 'modal-basic-title',centered: true }).result.then((result) => {  
      if (result === 'yes') {  
        let param = {
          patient_id:item.appointment.patient_id,
          app_id:item.appointment.app_id,
          status:"cancelled",
        }
        // this.api.updateAppointment(param).subscribe({
        //   next:(res)=>{
        //     this.modalService.dismissAll();
        //     this.toast.success("Appointment Cancelled Successfully")
        //     this.loadData()
        //   },
          
        //   error:(e)=>{
    
        //   }
        // })
      }  
    }, (reason) => {  

    });  
  }

  discharge(content:any,item:any)
  {
    this.modalService.open(content,  { size:'sm', scrollable: false,ariaLabelledBy: 'modal-basic-title',centered: true }).result.then((result) => {  
      if (result === 'yes') {  
        let param = {
          patient_id:item.appointment.patient_id,
          app_id:item.appointment.app_id,
          status:'check_out',
        }
        // this.api.updateAppointment(param).subscribe({
        //   next:(res)=>{
        //     this.modalService.dismissAll();
        //     this.loadData()
        //     this.toast.success("Appointment Updated Successfully")
        //   },
        //   error:(e)=>{
    
        //   }
        // })
      }  
    }, (reason) => {  

    });  
  }
  checkInIpd(item:any)
  {
    
    if(item.pId=='N/A' || item.ipdappointment.ipd_number=='N/A' || item.appointment.opd_number=='' )
    {
     // alert('if')
      let param = {
        hospital_id:this.localStorage.getHospitalId(),
        center_id:this.localStorage.getCenterId(),
        patient_id:item.id,
        ipd_app_id:item.ipdappointment.id,
        pId:item.pId,
        ipd_number:item.ipdappointment.ipd_number,
        status:"check_in"
      }
      console.log(param)
      this.api.checkInIpdPatientData(param).subscribe({
        next:(res)=>{
          if(res)
          {
            this.toast.success('Patient Checked IN IPD')
            setTimeout(() => {
              this.router.navigate(['main/in-patient/record/'+item.id+'/'+item.ipdappointment.id])
            }, 500);
          
          }
        },
        error:(e)=>{}
      })
    }
    else
    {
     // alert('else')
     this.router.navigate(['main/appointments/record/'+item.id+'/'+item.appointment.app_id])
    }
   
  }
  checkIn(content:any,item:any)
  {
    this.modalService.open(content,  { size:'sm', scrollable: false,ariaLabelledBy: 'modal-basic-title',centered: true }).result.then((result) => {  
      if (result === 'yes') {  
        this.checkInIpd(item);
      }  
    }, (reason) => {  

    });  
  }

  export(header:any)
  {
    //console.log(header)
    let excelRowData:any = [];
    this.exportArrayData.forEach((element:any) => {
     let status = "";
     if( element.ipdappointment.status=="booked")
     {
       status = element.ipdappointment.status.replaceAll('booked','Booked')
     }
     else if( element.ipdappointment.status=="check_in" )
     {
       status = element.ipdappointment.status.replaceAll('check_in','Checked In')
     }
     else if( element.ipdappointment.status=="rescheduled" )
     {
       status = element.ipdappointment.status.replaceAll('rescheduled','Rescheduled')
     }
     else if( element.ipdappointment.status=="discharge")
     {
       status = element.ipdappointment.status.replaceAll('discharge','Discharged')
     }

     else if( element.ipdappointment.status=="cancelled")
     {
       status = element.ipdappointment.status.replaceAll('cancelled','Cancelled')
     }

     excelRowData.push({0:element.pId,1:element.ipdappointment.ipd_number,2:element.fname+" "+element.lname,3:element.ipdappointment.doctor_incharge.fname+" "+element.ipdappointment.doctor_incharge.lname,4:element.ipdappointment.date_of_admission,5:element.ipdappointment.time_of_admission,6:status})
   });

    let excelData = [];
    let excelHeader = [];
      for (let i = 0; i < excelRowData.length; i++) {
        let element = excelRowData[i];
        let obj:any = {}
        for (let index = 0; index < header.length; index++) {
          let key = header[index]['key'];
          obj[key] = element[key]
        }
        excelData.push(obj)
      }
      for (let index = 0; index < header.length; index++) {
        let value = header[index]['value'];
        excelHeader.push(value)
      }
    //console.log(excelData)
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(ws, [excelHeader]);
    XLSX.utils.sheet_add_json(ws,excelData, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    let date = new Date();
    let day = date.getDate();
    let month = date.getMonth()+1;
    let year = date.getFullYear();

  XLSX.writeFile(wb, "In_Patient_"+day+"_"+month+"_"+year+"_"+date.getTime()+".csv");
  }

@HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobileView = window.innerWidth <= 1024;
  }

handleScrollLeft() {
  const container = this.scrollContainer.nativeElement;
  container.scrollBy({ left: -150, behavior: 'smooth' });
  setTimeout(() => this.updateScrollThumb(), 300);
}

handleScrollRight() {
  const container = this.scrollContainer.nativeElement;
  container.scrollBy({ left: 150, behavior: 'smooth' });
  setTimeout(() => this.updateScrollThumb(), 300);
}

updateScrollThumb() {
  if (!this.scrollContainer) return;

  const container = this.scrollContainer.nativeElement;
  const scrollWidth = container.scrollWidth;
  const clientWidth = container.clientWidth;
  const scrollLeft = container.scrollLeft;

  if (scrollWidth > clientWidth) {
    this.scrollThumbWidth = Math.max(10, Math.min(100, (clientWidth / scrollWidth) * 100));
    const maxScrollLeft = scrollWidth - clientWidth;
    const scrollPercentage = (scrollLeft / maxScrollLeft) * 100;
    this.scrollThumbLeft = (scrollPercentage * (100 - this.scrollThumbWidth)) / 100;
    this.scrollThumbLeft = Math.max(0, Math.min(100 - this.scrollThumbWidth, this.scrollThumbLeft));
  } else {
    this.scrollThumbWidth = 100;
    this.scrollThumbLeft = 0;
  }
}

  toggleStatusFilter(status: string) {
    if (this.selectedStatus === status) {
      this.selectedStatus = '';
    } else {
      this.selectedStatus = status;
    }
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.statusFilter$.next(this.selectedStatus);
  }

  loadAppointmentByTab(type: string) {
    this.selectedStatus = '';
    this.statusFilter$.next('');
    if (type === "all") {
      this.dateFilter("");
      this.selected_tab = 'all';
    } else if (type === "today") {
      this.dateQuery.setValue({ startDate: new Date(), endDate: new Date() });
      this.selected_tab = 'today';
    } else if (type === "tomorrow") {
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      this.dateQuery.setValue({ startDate: tomorrow, endDate: tomorrow });
      this.selected_tab = 'tomorrow';
    } else if (type === "week") {
      const today = new Date();
      const dayOfWeek = today.getDay();
      const startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - dayOfWeek);
      const endOfWeek = new Date(today);
      endOfWeek.setDate(today.getDate() + (6 - dayOfWeek));
      this.dateQuery.setValue({ startDate: startOfWeek, endDate: endOfWeek });
      this.selected_tab = 'week';
    } else if (type === "month") {
      const today = new Date();
      const currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
      const currentMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      this.dateQuery.setValue({ startDate: currentMonthStart, endDate: currentMonthEnd });
      this.selected_tab = 'month';
    }
  }

  fetchOverviewStats(param: any) {
    const countParam = {
      ...param
    };
    if (countParam.status) {
      delete countParam.status;
    }
    this.overviewStatsSubject.next(countParam);
  }

  getTabOverviewTitle(): string {
    switch (this.selected_tab) {
      case 'today':
        return "Today's Overview";
      case 'tomorrow':
        return "Tomorrow's Overview";
      case 'week':
        return "Week's Overview";
      case 'month':
        return "Month's Overview";
      default:
        return "Overall Overview";
    }
  }

  openReportsModal(content: any) {
    this.modalService.open(content, { size: 'xl', scrollable: true, centered: true, windowClass: 'modal-reports-popup' });
  }

  openRemindersModal(content: any) {
    this.reminderFollowUp = false;
    this.reminderUpcoming = false;
    this.reminderSending = false;
    this.modalService.open(content, { size: 'md', scrollable: false, centered: true, windowClass: 'modal-reminders-popup' });
  }

  sendReminders(modal: any) {
    if (!this.reminderFollowUp && !this.reminderUpcoming) return;
    this.reminderSending = true;
    const types: string[] = [];
    if (this.reminderFollowUp) types.push('follow_up');
    if (this.reminderUpcoming) types.push('upcoming');
    setTimeout(() => {
      this.reminderSending = false;
      this.toast.success(`Reminders sent to ${types.join(' & ')} patients`, 'Success');
      modal.dismiss();
    }, 1500);
  }

  getFollowUpPatients(): any[] {
    if (!this.dataSource?.data) return [];
    return this.dataSource.data.filter(item => {
      const status = (item.ipdappointment?.status || '').toLowerCase();
      // follow-up/booked patients
      return status === 'booked';
    });
  }

  getUpcomingPatients(): any[] {
    if (!this.dataSource?.data) return [];
    const todayStr = moment().format('YYYY-MM-DD');
    const tomorrowStr = moment().add(1, 'day').format('YYYY-MM-DD');
    return this.dataSource.data.filter(item => {
      const d = item.ipdappointment?.date_of_admission ? moment(item.ipdappointment.date_of_admission).format('YYYY-MM-DD') : '';
      return d === todayStr || d === tomorrowStr;
    });
  }

  getSelectedPatients(): any[] {
    const list: any[] = [];
    const seenIds = new Set<any>();

    const addToList = (patients: any[]) => {
      patients.forEach(p => {
        const id = p.ipdappointment?.id;
        if (id && !seenIds.has(id)) {
          seenIds.add(id);
          list.push(p);
        }
      });
    };

    if (this.reminderFollowUp) {
      addToList(this.getFollowUpPatients());
    }
    if (this.reminderUpcoming) {
      addToList(this.getUpcomingPatients());
    }
    return list;
  }

  getSelectedPatientsCount(): number {
    return this.getSelectedPatients().length;
  }

  showFilterData(event: any) {
    if (event) {
      this.loadDepartments();
      this.loadDoctorsByDepartments();
    }
  }

  loadDepartments() {
    let param = {
      where: {
        hospital_id: this.localStorage.getHospitalId(),
        isPublic: true,
      }
    };
    // Fetch departments from user/master service
    this.user.getAllDepartment(param).subscribe({
      next: (response) => {
        if (response && response.length > 0) {
          this.departmentListDp = response;
        }
      },
      error: (e) => {}
    });
  }

  loadDoctorsByDepartments() {
    let param = {
      hospital_id: this.localStorage.getHospitalId(),
      center_id: this.localStorage.getCenterId(),
      roles: ['Doctor', 'Ophthalmologist', 'Surgeon']
    };
    this.user.getDoctors(param).subscribe({
      next: (response) => {
        this.DoctorDpList = response;
      },
      error: (e) => {}
    });
  }

  showInfo(row: any, event: any) {
    this.hoveredRow = row;
    this.topPosition = event.clientY;
    this.leftPosition = event.clientX;
    this.current_id_hover = row.ipdappointment.id;
  }

  onMouseMove(row: any, event: MouseEvent): void {
    this.current_id_hover = row.ipdappointment.id;
  }

  hideInfo() {
    this.current_id_hover = "";
    this.mobileInfoVisible = null;
  }

  toggleMobileInfo(element: any) {
    this.mobileInfoVisible = this.mobileInfoVisible === element.ipdappointment.id ? null : element.ipdappointment.id;
    if (window.innerWidth > 768) {
      this.current_id_hover = "";
    }
  }

  handleShowInfo(element: any, event: any) {
    this.showInfo(element, event);
    this.toggleMobileInfo(element);
  }

  customSearchFilter(event: any) {
    this.filtersObject = event;
    this.loadData();
  }
}

export class IpdAppointment {
  prefix:string = "";
  fname:string = "";
  lname:string = "";
  mobile:string= "";
  email:string= "";
  age:string = "";
  gender:string = "";
  guardian:string = "";
  pId:string = "";
  address:string = "";
  patient_id:Number = 0;
  ipd_number:string = "";
  date_of_admission:string = "";
  time_of_admission:string = "";
  day_care:boolean = true;
  reason_for_admission:[] = [];
  diagnosis:[] = [];
  procedures:[] = [];
  room_no:string = "";
  room_type:string = "";
  doctor_incharge:[] = [];
  significant_finding:string = "";
  lama:string = "";
  mlc:string = "";
  hospital_id:Number = 0;
  center_id:Number = 0;
  status:string = "booked";
}


